{
  "back": "Back",
  "bookmarksMenu": "Menu",
  "change": "Change",
  "closeBookmarksMenu": "Close menu",
  "closeDialog": "Close",
  "colonoscopy": "Colonoscopy",
  "continue": "Continue",
  "details": "Details",
  "errors": {
    "invalidOtp": {
      "details": "<ul><li>Check for any typos and try again.</li><li>If you’re stuck, call us on {{phone}} (press Option 2).</li></ul>",
      "title": "That didn’t match our records"
    },
    "serverErrorOtp": {
      "details": "<ul><li>Your details might be correct – but we were unable to verify them right now.</li><li>Please wait a moment and try again.</li></ul>",
      "title": "Something went wrong."
    },
    "uploadFailed": {
      "details": "<ul><li>Something unexpected occurred when uploading your attachment.</li><li>Please wait a moment and try again.</li></ul>",
      "title": "Attachment upload failed."
    }
  },
  "formattedDate": "{{date}} at {{time}}",
  "gastroscopy": "Gastroscopy",
  "loading": "Loading...",
  "next": "Next",
  "nextWeek": "Next week",
  "no": "No",
  "none": "None",
  "openBookmarksMenu": "Open menu",
  "optional": "Optional",
  "prevWeek": "Previous week",
  "progress": "Progress {{progress}}%",
  "roles": {
    "GeneralPractitioner": "GP",
    "Specialist": "Specialist"
  },
  "selectLanguage": "Select language",
  "step": {
    "appointment": "Appointment Time",
    "details": "Personal details",
    "health-questions": "Health questions",
    "history": "Past procedures or surgeries",
    "insurance": "Health insurance",
    "medications": "Medications",
    "preference-questions": "Preference questions",
    "specialist": "Specialist"
  },
  "timeToday": "{{time}} today",
  "timeTomorrow": "{{time}} tomorrow",
  "videoUnsupported": "Your browser does not support the video tag.",
  "yes": "Yes",
  "yesTo": "Yes to",
  "yourProgress": "Your progress"
}
